import { useEffect, useRef } from "react";

const GoogleAddressAutocomplete = ({ type, value, onChange = () => {}, onSelect }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const listenerRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  useEffect(() => {
  const styleId = "google-autocomplete-pac-container-style";
  if (document.getElementById(styleId)) return undefined;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    .pac-container {
      z-index: 99999 !important;
      position: fixed !important;
    }
  `;
  document.head.appendChild(style);

  return () => {
    style.remove();
  };
}, []);
  useEffect(() => {
    if (!inputRef.current) return undefined;

    let cancelled = false;
    let retryTimer = null;

    const initializeAutocomplete = () => {
      if (cancelled) return;

      if (!window.google?.maps?.places || !inputRef.current) {
        retryTimer = window.setTimeout(initializeAutocomplete, 250);
        return;
      }

      if (!autocompleteRef.current) {
        autocompleteRef.current = new window.google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["geocode"],
            fields: ["address_components", "geometry", "formatted_address"],
          },
        );
      }

      if (listenerRef.current) {
        window.google.maps.event.removeListener(listenerRef.current);
      }

      listenerRef.current = autocompleteRef.current.addListener("place_changed", () => {
        const place = autocompleteRef.current.getPlace();

        if (!place.address_components || !place.geometry?.location) return;

        const result = {
          address: "",
          city: "",
          state: "",
          country: "",
          zipCode: "",
          latitude: null,
          longitude: null,
        };

        place.address_components.forEach((component) => {
          const types = component.types;

          if (types.includes("street_number")) {
            result.address = component.long_name + " ";
          }

          if (types.includes("route")) {
            result.address += component.long_name;
          }

          if (types.includes("locality") || types.includes("postal_town")) {
            result.city = component.long_name;
          }
          if (!result.city && types.includes("administrative_area_level_2")) {
            result.city = component.long_name;
          }

          if (!result.city && types.includes("sublocality")) {
            result.city = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            result.state = component.long_name;
          }
          if (types.includes("country")) {
            result.country = component.long_name;
          }
          if (types.includes("postal_code")) {
            result.zipCode = component.long_name;
          }
        });

        result.address = place.formatted_address || result.address || "";
        result.latitude = place.geometry.location.lat() ?? null;
        result.longitude = place.geometry.location.lng() ?? null;

        onSelect?.(result);
      });
    };

    initializeAutocomplete();

    return () => {
      cancelled = true;
      if (retryTimer) {
        window.clearTimeout(retryTimer);
      }
      if (listenerRef.current) {
        window.google.maps.event.removeListener(listenerRef.current);
        listenerRef.current = null;
      }
    };
  }, [onSelect]);

  useEffect(() => {
    const styleId = "google-autocomplete-pac-container-style";
    if (document.getElementById(styleId)) return undefined;

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .pac-container {
        z-index: 9999 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);

  return (
    <input
      ref={inputRef}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      type="text"
      placeholder="Search location"
      className={`w-full px-4 py-3 bg-white ${type === "updated" ? "rounded-full" : "rounded-lg"} border border-gray-200 focus:outline-none focus:border-primary`}
      onKeyDown={handleKeyDown}
    />
  );
};

export default GoogleAddressAutocomplete;
